/** This helper class is here until we implement the full otel library */

export const TRACEPARENT_HEADER = 'traceparent'

// Generates the final string in the format: 00-traceId-spanId-01
export function generateTraceParent(): [string, string] {
  const traceId = generateTraceId()
  const spanId = generateSpanId()
  const traceIdHex = formatBigIntHex(traceId, 32) // 128 bits = 32 hex characters
  const spanIdHex = formatBigIntHex(spanId, 16) // 64 bits = 16 hex characters
  return [`00-${traceIdHex}-${spanIdHex}-01`, traceIdHex]
}

const INVALID_SPAN_ID = BigInt('0x0000000000000000') // Invalid span ID
const INVALID_TRACE_ID = BigInt('0x00000000000000000000000000000000') // Invalid trace ID

function formatBigIntHex(num: bigint, length: number): string {
  let hex = num.toString(16)
  while (hex.length < length) {
    hex = '0' + hex
  }
  return hex
}

function getRandomBits(bits: number): bigint {
  let result = BigInt(0)
  let bitsRemaining = bits
  while (bitsRemaining > 0) {
    // Use a chunk size of up to 32 bits.
    const chunkSize = Math.min(bitsRemaining, 32)
    const maxForChunk = Math.pow(2, chunkSize)
    const randomChunk = Math.floor(Math.random() * maxForChunk)
    result = (result << BigInt(chunkSize)) | BigInt(randomChunk)
    bitsRemaining -= chunkSize
  }
  return result
}

function generateSpanId(): bigint {
  let spanId = getRandomBits(64)
  while (spanId === INVALID_SPAN_ID) {
    spanId = getRandomBits(64)
  }
  return spanId
}

function generateTraceId(): bigint {
  let traceId = getRandomBits(128)
  while (traceId === INVALID_TRACE_ID) {
    traceId = getRandomBits(128)
  }
  return traceId
}
